module.exports = __webpack_public_path__ + "img/brand.464e89c4.webp";